import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';

const CartItemSkeleton = () => {
  return (
    <Box id="cart-item-skeleton" aria-label="loading-cart-item" width="100%">
      <Box display="flex" justify="space-evenly" pt={2} pb={2}>
        <Box display="flex" alignContent="flex-start" flexBasis="30px">
          <Skeleton
            animation="wave"
            variant="rectangular"
            width={32}
            height={42}
            style={{ marginRight: '1rem', animationDuration: '0.6s' }}
          />
        </Box>
        <Box flex="2">
          <Skeleton
            animation="wave"
            variant="rectangular"
            width={240}
            height={64}
            style={{ animationDuration: '0.6s' }}
          />
        </Box>
        <Skeleton
          animation="wave"
          variant="rectangular"
          width={66}
          height={64}
          style={{ animationDuration: '0.6s' }}
        />
      </Box>
    </Box>
  );
};

export default CartItemSkeleton;
